import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  max-width: 64.875rem;
  
  display: flex;
  flex-direction: column;
  
  border-radius: 1rem;
  background-color: ${theme.colors.gray.Cinza_13};
`;

export const HeaderContainer = styled.div`
  padding: 1rem;
  
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 950px) {
    gap: 1rem;
    flex-direction: column;
  }
`

export const ContainerWrapperPrimary = styled.div`
  gap: 1rem;
  display: flex;
  
  align-items: center;
`

export const ContainerWrapperSecondary = styled.div`
  gap: 1.5rem;
  display: flex;
  align-items: center;
  
  a {
    gap: 0.5rem;
    display: flex;
   
    align-items: center;
  }

  @media (max-width: 950px) {
    flex-direction: column-reverse;
  }
`

export const NewRecipe = styled.button`
  all: unset;
  padding: 0.75rem 1.5rem;
  
  gap: 0.5rem;
  display: flex;
  align-items: center;

  transition: 300ms;
  cursor: pointer;
  border-radius: 2.5rem;
  text-transform: uppercase;
  border: 0.0625rem solid black;

  p {
    cursor: pointer;
  }

  &:hover {
    transition: 300ms;
    background-color: #ececec;
  }
`;

export const BoxesWrapper = styled.div`
  width: auto;
  height: auto;
  
  gap: 1rem;
  display: flex;
  margin-inline: 1rem;
  margin-block: 0 1rem;
  
  overflow: hidden;
  overflow-x: scroll;
  border-radius: 0.5rem;

  ::-webkit-scrollbar {
    display: none;
  }
`

export const Boxes = styled.div`
  width: 100%;
  cursor: pointer;
  padding: 0.75rem;
  min-width: 14.969rem;
  max-width: 14.969rem;
  
  gap: 0.5rem;
  display: flex;
  justify-content: space-around;
  
  border-radius: 0.5rem;
  flex-direction: column;
  background-color: ${theme.colors.white.Branco};
`

export const HeaderBoxes = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  overflow-x: auto;

  >h6{
    white-space: nowrap;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 0px;
    height: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888; 
    border-radius: 8px;
    
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
`

export const FooterBoxes = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const BelowFooter = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  img:nth-child(2) {
    width: 1.5rem;
    height: 1.5rem;

    border-radius: 10rem;
  }
`

export const CropBadge = styled.span`
    padding: 0.4rem 0.5rem;
    
    margin-right: 0.5rem;
    
    border-radius: 3rem;
    background-color: ${theme.colors.gray.Cinza_2};
`;

export const FarmLocation = styled.p`
    width: auto;
    padding: 0.5rem;
    max-width: 10rem;
    
    gap: 0.2rem;
    display: flex;
    margin: 0.25rem 0;

    align-items: center;
    border-radius: 999px;
    background-color: ${theme.colors.gray.Cinza_12};

    p {
      max-width: 6.25rem;
      
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
      text-overflow: ellipsis;
      text-transform: uppercase;
    }

    @media (max-width: 360px) {
        font-size: 0.47rem;
    }
  
`;

export const ProfilePlaceholder = styled.div`
  width: 2rem;
  height: 2rem;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  color: white;
  font-weight: bold;
  border-radius: 50%;
  font-size: 0.75rem;
  background-color: ${theme.colors.gray.Cinza_2};
`;
